import React, { useState }  from 'react'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
const sample = [{speaker:'You',msg:'What is CoreWeave?'},{speaker:'AI',msg:'CoreWeave is a cloud-computing company that provides a scalable and secure infrastructure for high-performance computing, artificial intelligence, and machine learning workloads.'}]
export default function LlmRag() {
    const [loadingMsg, setLoadingMsg]= useState(false)
    const [script, setScript]= useState(sample)
    const [userInput, setUserInput] = useState({question:'What is CoreWeave?'})
    const onChange2Input = ({ currentTarget: x }) => { setUserInput({ ...userInput, [x.name]: x.value }) }
    const onClick2Rag1=async()=>{
        script.push({speaker:'You',msg:userInput.question})
        setLoadingMsg(true)
        try {
            const { data: res } = await axios.post(`${APIURL}/llm/rag1`,userInput)
            console.log(res)
            setLoadingMsg(false)
            script.push({speaker:'AI','msg':res['answer']})
        } catch (err) {
            console.log(err)
        }
    }
    const a = 'abc'
    return (
        <>
        <p className='text-[8px] mt-[4px] mb-[4px]'>
        <b>Added .md documents include:</b><br/>
        Company Name: CoreWeave<br/>
        Product: NVIDIA GB200 NVL72<br/>
        Employee Information<br/>
        </p>
        <p className='text-[8px] mb-[4px]'>
        <b>Sample Question to Ask</b><br/>
        What is CoreWeave?<br/>
        What product CoreWeave sell?<br/>
        Who is Chief Executive Officer  at CoreWeave?<br/>
        {a}
        </p>
        <div className='mt-[2px] flex'>
        <input className='pl-[2px] border border-gray-800 w-full md:w-80 mr-[2px]'  name='question' type='text' defaultValue='What is CoreWeave?' onChange={onChange2Input}/>
        <button className='bg-gray-800 hover:bg-gray-700 h-auto pl-[8px] pr-[8px] text-white text-[12px]' onClick={onClick2Rag1}>Ask to AI</button>
        </div>
       <div className='text-left'>
        <>{script.map((x)=><>{x.speaker}: {x.msg}<br/></>)}</>
        {loadingMsg?<p className='flex text-xs'>Please wait for a moment<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>:''}
       </div>
       </>
    )
}